// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1UuAk","inner":"Footer_inner__2Glm7"};